/**
 * Regras puras da Entrada (RN-16) e das mensagens de erro do servidor. Separadas dos componentes
 * para serem testadas sem rede.
 */
import type { PastaEtapasTravadas } from "./api";

export type DecisaoMovimento =
  /** Pasta saindo da Entrada: abre o checkout em vez de mover. */
  | "checkout"
  /** Destino é etapa do sistema (Entrada ou Pagamento aprovado): ninguém coloca negócio ali. */
  | "etapa_do_sistema"
  /** Movimento normal. */
  | "livre";

/**
 * O que fazer quando alguém arrasta um negócio na pipeline de entrega do escritório. O servidor
 * recusa os mesmos casos (trigger `pasta_trava_*`); isto só evita a ida e volta e abre o checkout.
 */
export function decidirMovimento(
  etapas: PastaEtapasTravadas | null | undefined,
  deStageId: string | null | undefined,
  paraStageId: string,
): DecisaoMovimento {
  if (!etapas) return "livre";
  if (deStageId && deStageId === paraStageId) return "livre";
  if (deStageId && deStageId === etapas.entrada_stage_id) return "checkout";
  if (paraStageId === etapas.entrada_stage_id || paraStageId === etapas.pagamento_stage_id) {
    return "etapa_do_sistema";
  }
  return "livre";
}

interface ErroComMensagem {
  message?: string;
  code?: string;
}

/** Erro de RPC que não existe no banco (função de outra frente ainda não aplicada). */
export function rpcInexistente(err: unknown): boolean {
  const e = (err ?? {}) as ErroComMensagem;
  return e.code === "PGRST202" || e.code === "42883" || /could not find the function/i.test(e.message ?? "");
}

/** Traduz os erros conhecidos do servidor para o texto da tela; null quando não é um deles. */
export function mensagemErroPasta(err: unknown): string | null {
  const msg = ((err ?? {}) as ErroComMensagem).message ?? "";
  if (msg.startsWith("pasta_bloqueada")) {
    return "Esta pasta está na Entrada: ela só avança depois do pagamento.";
  }
  if (msg.startsWith("etapa_do_sistema")) {
    return "Entrada e Pagamento aprovado são movidas só pelo sistema.";
  }
  return null;
}

export function formatarValor(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return "—";
  return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
